module.exports = __webpack_public_path__ + "static/media/alerta-taller-rojo.d5a768be.svg";